export const RESULTS_PER_PAGE_48 = 48;
